import { useCallback, useState } from 'react'

import { ServiceItem } from '../../../hooks/useTransformServiceItems/useTransformServiceItems'
import { getTotalPrice } from './OrderCartDialog'
// state for the popup dialogue
export interface OrderPartsAttempt {
  serviceItem: ServiceItem
  prevPrice: number
  orderType: 'PartsTech' | 'RepairLink'
}

export interface OrderPartAction {
  orderPartsAttempts: OrderPartsAttempt[]
  curOrderIndex: number
}
export const useOrderCart = (serviceItems: ServiceItem[] | undefined) => {
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [orderPartAction, setOrderPartAction] =
    useState<OrderPartAction | null>(null)
  const handleOrderCart = useCallback(
    async (serviceIds: string[]) => {
      const orderPartsAttempts: OrderPartsAttempt[] = []

      serviceIds.forEach((serviceId) => {
        const serviceItem = serviceItems?.find((s) => s.id === serviceId)!
        const { totalPrice: prevPricePartsTech } = getTotalPrice(
          serviceItem.partsInCart
        )
        const { totalPrice: prevPriceRepairLink } = getTotalPrice(
          serviceItem.repairLinkPartsInCart
        )

        if (serviceItem.partsInCart.length !== 0) {
          orderPartsAttempts.push({
            serviceItem,
            prevPrice: prevPricePartsTech,
            orderType: 'PartsTech'
          })
        }
        if (serviceItem.repairLinkPartsInCart.length !== 0) {
          orderPartsAttempts.push({
            serviceItem,
            prevPrice: prevPriceRepairLink,
            orderType: 'RepairLink'
          })
        }
      })

      if (orderPartsAttempts.length === 0) {
        return
      }

      setIsSubmitting(true)

      setOrderPartAction({
        orderPartsAttempts,
        curOrderIndex: 0
      })

      setIsSubmitting(false)
    },
    [serviceItems]
  )

  return {
    orderPartAction,
    setOrderPartAction,
    handleOrderCart,
    isSubmitting,
    setIsSubmitting
  }
}
